"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Degrees = exports.Radian = void 0;
var uom_1 = require("uom");
/**
 * The unit for plane angle quantities ( <code>rad</code> ).
 * One radian is the angle between two radii of a circle such that the length of the arc between them is equal to the radius.
 */
exports.Radian = uom_1.Unit.createBase("Radian", "Angle", "rad");
exports.Degrees = uom_1.Unit.timesNumber("Degrees", Math.PI / 180.0, exports.Radian);
//# sourceMappingURL=angle.js.map